import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { StateUtils, StateWithProduct as StateWithSpartacusProduct } from '@spartacus/core';
import { CustomProductActions } from '../actions';
import {
  BONUSES,
  CALCULATORS,
  CALCULATOR_RESULT,
  GROUP_REFERENCES,
  PRICES,
  PRODUCT_CONDITIONS,
  PRODUCT_GROUP_REFERENCES,
  ProductState,
  SELECTED_PRICE,
} from '../product-state';
import { reducer as priceReducer } from './price.reducer';
import { reducer as bonusReducer } from './product-bonuses.reducer';
export type ProductReducers = Omit<ProductState, 'ticket'>;

export function getReducers(): ActionReducerMap<ProductReducers> {
  return {
    selectedPrice: StateUtils.entityLoaderReducer(SELECTED_PRICE),
    prices: StateUtils.entityLoaderReducer(PRICES, priceReducer),
    bonuses: StateUtils.entityLoaderReducer(BONUSES, bonusReducer),
    calculatorList: StateUtils.entityLoaderReducer(CALCULATORS),
    calculatorResult: StateUtils.loaderReducer(CALCULATOR_RESULT),
    groupReferences: StateUtils.entityLoaderReducer(GROUP_REFERENCES),
    productGroupReferences: StateUtils.entityLoaderReducer(PRODUCT_GROUP_REFERENCES),
    productConditions: StateUtils.entityLoaderReducer(PRODUCT_CONDITIONS),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ProductReducers>> = new InjectionToken<
  ActionReducerMap<ProductReducers>
>('ProductReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function resetProductFactory(): MetaReducer<StateWithSpartacusProduct> {
  const metaReducer =
    (reducer: ActionReducer<StateWithSpartacusProduct>): ActionReducer<StateWithSpartacusProduct> =>
    (
      state: StateWithSpartacusProduct,
      action: CustomProductActions.ProductDetailResetState,
    ): StateWithSpartacusProduct => {
      if (action.type === CustomProductActions.PRODUCT_DETAIL_RESET_STATE) {
        const newState = {
          ...state,
          product: {
            ...state.product,
            details: { entities: {} },
          },
        };

        return reducer(newState, action);
      }

      return reducer(state, action);
    };

  return metaReducer;
}
